import { render, staticRenderFns } from "./ActivecampaignTagSent.vue?vue&type=template&id=2cfcfa17&scoped=true&"
import script from "./ActivecampaignTagSent.vue?vue&type=script&lang=js&"
export * from "./ActivecampaignTagSent.vue?vue&type=script&lang=js&"
import style0 from "./ActivecampaignTagSent.vue?vue&type=style&index=0&id=2cfcfa17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfcfa17",
  null
  
)

export default component.exports